import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { getStatisticSagaAction } from "../../../redux/sagaActions";
import { statisticDatesAction } from "../../../redux/rootReducer";
import CalendarOffline from "../../CalendarOffline/CalendarOffline";

const StatisticHeader = () => {
    const dispatch = useDispatch();
    const statistic_dates = useSelector(state => state.statistic_dates);

    // Состояние календаря
    const [openFromCalendar, setOpenFromCalendar] = useState(false);
    const [openToCalendar, setOpenToCalendar] = useState(false);

    return (
        <>
            <div className="header__dates">
                <div className="flt__box">
                    <div className="flt__title">Начало периода</div>
                    <div className="input input--datepicker"
                         onClick={ event => {
                             event.preventDefault();
                             event.stopPropagation();
                             setOpenFromCalendar(!openFromCalendar);
                         } }
                    >{ statistic_dates.from ? new Date(statistic_dates.from).toLocaleDateString('ru-Ru') : '' }</div>
                    <CalendarOffline
                        date={ statistic_dates.from }
                        handler={ date => {
                            dispatch(statisticDatesAction({
                                ...statistic_dates,
                                from: date
                            }));
                            setOpenFromCalendar(false);
                        } }
                        open={ openFromCalendar }
                        close={ () => setOpenFromCalendar(false) }
                    />
                </div>
                <div className="flt__box">
                    <div className="flt__title">Окончание периода</div>
                    <div className="input input--datepicker"
                         onClick={ event => {
                             event.preventDefault();
                             event.stopPropagation();
                             setOpenToCalendar(!openToCalendar);
                         } }
                    >{ statistic_dates.to ? new Date(statistic_dates.to).toLocaleDateString('ru-Ru') : '' }</div>
                    <CalendarOffline
                        date={ statistic_dates.to }
                        handler={ date => {
                            dispatch(statisticDatesAction({
                                ...statistic_dates,
                                to: date
                            }));
                            setOpenToCalendar(false);
                        } }
                        open={ openToCalendar }
                        close={ () => setOpenToCalendar(false) }
                    />
                </div>
                <div className="flt__box">
                    <div className="button button--blue"
                        onClick={ () => dispatch(getStatisticSagaAction({
                            date_from: statistic_dates.from,
                            date_to: statistic_dates.to
                        })) }
                    >Применить</div>
                </div>
            </div>
        </>
    );
};

export default StatisticHeader;